import clsx from 'clsx'
import React, {FC,useEffect, useRef, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks} from '../../../partials'
import {useLayout} from '../../core'
import config1 from '../../../../config.json'
import {decryptData} from '../../../../app/modules/auth/components/util';

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const {config} = useLayout()
 const points = '123';
 const salt = process.env.SALT || '6d090796-ecdf-11ea-adc1-0242ac112345';
  var clientId='',decryptedToken='';
  const token = localStorage.getItem('paramValue');
  const encryptedclientId = localStorage.getItem('clientId');
  if(encryptedclientId){
    clientId = decryptData(encryptedclientId, salt);
    decryptedToken = decryptData(token,salt);
  }
  //const intl = useIntl()
  const [pointsValue, setPointsValue] = useState<string>('');
  const [dataFetched, setDataFetched] = useState<boolean>(false);
  const [colorCode,setColorCode] =useState("#F36D2F");
  const fetchPointsData = async () => {
    try {
     const formData = new FormData();
    formData.append('clientId',clientId);
    formData.append('token',decryptedToken);
 
      const basicAuth = 'Basic ' + btoa(`${config1.API_USERNAME}:${config1.API_PASSWORD}`);
      const url = `${config1.apiUrl}/bmpportal/getPoints`;
      const response = await fetch(url,{
        method:'POST',
        headers: {
          'Authorization': basicAuth,
         // 'Content-Type': 'application/json'
        },
        body:formData
      });
      if (response.ok) {
        const data = await response.json();
      if (data.allowanceAvaliable  && data.totalAllowance && data.type) {
        if(data.type =="free"){
        setPointsValue(data.allowanceAvaliable+' / '+data.totalAllowance);
        setColorCode("#F36D2F");
        }else{
          setPointsValue('- '+data.allowanceAvaliable+' / '+data.totalAllowance);
          setColorCode("red");
        }
        //alert(pointsValue)
        setDataFetched(false);
      } else {
        console.error('Unexpected API response:', data);
      }
    } else {
      console.error('Failed to fetch data. Status:', response.status);
    }


} catch (error) {
  console.error('Error fetching data:', error);
}
};


 useEffect(() => {

    fetchPointsData();

  }, []);

  useEffect(() => {
    // Fetch data from API when the component mounts
    if (clientId && dataFetched) {
      fetchPointsDataFromAPI(clientId, setPointsValue,setColorCode);
      setDataFetched(false);
    }
    console.log(pointsValue);
  }, [pointsValue]);


  return (
    
    <div className='d-flex align-items-stretch flex-shrink-0'>

    <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
   
<div id="pointsDisplayDiv"  style={{
  width: "100%",
  height: "40px",
  background: `${colorCode}`,
  borderRadius: "32px",
  border: `2px solid ${colorCode}`,
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 10px",
}}>
  <i className="bi bi-envelope" style={{ color: "white", fontSize: "15px" }}></i>
  <span>&nbsp;&nbsp;&nbsp;&nbsp;{pointsValue} Remaining</span>
</div>

</div>

    {/* begin::User */}
    <div
      className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
      id='kt_header_user_menu_toggle'
    >
      <div
        className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
        data-kt-menu-trigger='click'
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='bottom'
      >
        <img src={toAbsoluteUrl('/media/avatars/150-2.jpg')} alt='metronic' />
      </div>
      <HeaderUserMenu />
    </div> 
    {/* end::User */}

    {/* begin::Aside Toggler */}
    {config.header.left === 'menu' && (
      <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
        <div
          className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
          id='kt_header_menu_mobile_toggle'
        >
          <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
        </div>
      </div>
    )}
  </div>

  )
}


export async function fetchPointsDataFromAPI(clientId: string,token:string ,setPointsValue: React.Dispatch<React.SetStateAction<string>>,setColorCode: React.Dispatch<React.SetStateAction<string>> ) {
  try {
     const formData = new FormData();
    formData.append('clientId',clientId);
    formData.append('token',token);
     //alert(token);
    const basicAuth = 'Basic ' + btoa(`${config1.API_USERNAME}:${config1.API_PASSWORD}`);
    const url = `${config1.apiUrl}/bmpportal/getPoints`;
    const response = await fetch(url,{
      method:'POST',
      headers: {
        'Authorization': basicAuth,
        //'Content-Type': 'application/json'
      },
      body:formData
    });
    if (response.ok) {
      const data = await response.json();
      if (data.allowanceAvaliable && data.totalAllowance && data.type) {
        var pointsValue="";
        if(data.type == "free"){
           pointsValue = `${data.allowanceAvaliable}/${data.totalAllowance}`;
           setColorCode("#F36D2F");
        }else{
          pointsValue = `- ${data.allowanceAvaliable}/${data.totalAllowance}`;
           setColorCode("red");
        }
        //const pointsValue = `${data.allowanceAvaliable}/${data.totalAllowance}`;

        console.log("points:::::"+pointsValue);
        setPointsValue(pointsValue);
        if(document.getElementById("pointsDisplayDiv") != null)
        {
                document.getElementById("pointsDisplayDiv").innerHTML= pointsValue + " Remaining";
        }

        //alert("setting value");
      } else {
        console.error('Unexpected API response:', data);
      }
    } else {
      console.error('Failed to fetch data. Status:', response.status);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export {Topbar}
